import { render, staticRenderFns } from "./ClassStudent.vue?vue&type=template&id=6cf9e400&scoped=true"
import script from "./ClassStudent.vue?vue&type=script&lang=js"
export * from "./ClassStudent.vue?vue&type=script&lang=js"
import style0 from "./ClassStudent.vue?vue&type=style&index=0&id=6cf9e400&prod&lang=scss&scoped=true"
import style1 from "./ClassStudent.vue?vue&type=style&index=1&id=6cf9e400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf9e400",
  null
  
)

export default component.exports